"use strict";

exports.__esModule = true;
exports.default = void 0;
/**
 * Converts list into array
 */
var _default = exports.default = Array.from;